module.exports = __webpack_public_path__ + "fonts/fa-v4compatibility.c9e50cca.woff2";